import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SwoService {

  uri = '';
  
  serviceselected = {};
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.uri = this.appConfigService.apiBaseUrl;
    
  }
  GetPagedServicesUrl() {
    return this.uri + '/ServiceWorkOrder/GetServiceWorkOrderPaged';
  }

  GetSwo(filter) {
    return this.http.post<any>(this.uri + '/ServiceWorkOrder', filter);
  }

  InsertUpdateSwo(model) {
    return this.http.post<any>(this.uri + '/ServiceWorkOrder/InsertUpdateServiceWorkOrder', model);
  }

  GetResponsible() {
    return this.http.post<any>(this.uri + '/ServiceTechnician', {});
  }

  GetResourceEmployees() {
    // return this.http.post<any>(this.uri + '/Employee', {} );
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_EmployeeListAll' });
  }

  GetServiceTypes() {
    return this.http.post<any>(this.uri + '/ServiceType', {});
  }

  GetServiceStatus() {
    return this.http.post<any>(this.uri + '/ServiceStatus', {});
  }

  GetProjectSales() {
    return this.http.post<any>(this.uri + '/ProjectSales/', {});
  }

  GetProjectByName(projectname: string) {
    return this.http.post<any>(this.uri + '/Project/GetProjectByName', { projectname: projectname } );
  }

  GetCustomerContacts() {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerContacts', { });
  }

  GetContactByName(name) {
    
    return this.http.post<any>(this.uri + '/Contacts/Get_AllContactsByName', { name: name });
  }

  GetServiceCategory(){
    return this.http.post<any>(this.uri + '/SerCategory', { });
  }

  GetCustomerSites() {
    // return this.http.post<any>(this.uri + '/Site/GetSitesCustomer', { CustomerId: 192 });
    return this.http.post<any>(this.uri + '/Site/GetSitesCustomer', { CustomerId: localStorage.getItem('customerid') });
  }
  
  GetSubContractors(){
    return this.http.post<any>(this.uri + '/SubContractors', { });
  }

  GetServicePriority() {
    return this.http.post<any>(this.uri + '/ServicePriority', { });
  }

  GetServiceCustomer() {
    // return this.http.post<any>(this.uri + '/ServiceWorkOrder/GetServiceCustomer', { CustomerId: 192 });
    return this.http.post<any>(this.uri + '/ServiceWorkOrder/GetServiceCustomer', { CustomerId: localStorage.getItem('customerid') });
  }

  GetServiceDetails(id) {
    return this.http.post<any>(this.uri + '/ServiceDetail/GetServiceDetailsCustomer', { serviceid: id });
  }

  GetServiceRecomendation(id) {
    return this.http.post<any>(this.uri + '/ServiceRecomendation', { serviceid: id });
  }
  
  GetTemplates(modulename) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ClientTemplateCE', modulename: modulename });
  }

  GetTemplatesByName(modulename) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ClientTemplateByCubeName', modulename: modulename });
  }

  DowloadDocument(filepath): Observable<any> {
    return this.http.post(this.uri + '/DownloadFile/Download', { filename: filepath });
  }
  
  Update_ServiceReason(id, notes){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Update_ServiceReason', serviceid: id, reasonforservice: notes });
  }
}
